var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('FormAd',{attrs:{"title":'Add Ad',"form":{region: null, branch: null, device: null, enabled: false}},on:{"submit":_vm.submit}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }